import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider } from "styled-components";
import { ModalProvider } from "../common-deprecated/containers/ModalProvider";
import Globalize from "../common-deprecated/Globalize";
import getTheme from "../common-deprecated/themes/getTheme";
import { renderReact } from "../common-deprecated/utils/clientRenderUtils";
import { type TradeInAemStateType, tradeInAemClientStore } from "./redux/store";
import { WindowDimensionsProvider } from "../common-deprecated/containers/WindowDimensionsProvider";
import { removeLastSlashAndWhiteSpace } from "../common-deprecated/utils";

export const getTradeInAemInit =
    (TradeInAem: React.ElementType) =>
    (target: string, _: unknown, initialState: TradeInAemStateType): void => {
        const { commonSettings } = initialState;
        const { country, culture } = commonSettings;

        // eslint-disable-next-line camelcase
        __webpack_public_path__ = `${removeLastSlashAndWhiteSpace(commonSettings.resourcePath)}/`;

        // Initialize store, tagging and globalize.
        const store = tradeInAemClientStore(initialState, commonSettings.component);
        Globalize(country, culture);

        renderReact(
            target,
            commonSettings,
            // Since react-redux 8, new development checks were introduced against incorrect usages of useSelector, mostly to detect unnecessary rerenders.
            // These checks were disabled for all existing components as these create quite some issues
            // Ideally these checks should be enabled in all components - UC-1220
            // Notice: Make sure to not add the 'stabilityCheck="never"' in new components
            <ReduxProvider store={store} stabilityCheck="never">
                <ThemeProvider theme={getTheme(commonSettings)}>
                    <WindowDimensionsProvider>
                        <ModalProvider>
                            <TradeInAem />
                        </ModalProvider>
                    </WindowDimensionsProvider>
                </ThemeProvider>
            </ReduxProvider>,
        );
    };
